import React from 'react';
import { grey } from '@mui/material/colors';
import { Add } from '@mui/icons-material';
import { Box, Button, capitalize, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { CloseReason } from '../../../types';
import { BpfCloseReasonType } from '../../../types';
import { CloseReasonField } from './CloseReasonField';
import { useBPFCloseReasonsMutations } from '../../../api';

interface Props {
  flowId: string;
  reasons: CloseReason[];
  type: BpfCloseReasonType;
}

export const CloseReasonSection = ({ reasons, flowId, type }: Props) => {
  const { actions, loading } = useBPFCloseReasonsMutations();

  const handleAddReason = async () => {
    await actions.handleCreateCloseReason({
      flowId,
      reason: { type, label: '', isActive: true },
    });
  };

  return (
    <Stack
      sx={{
        gap: '1rem',
        height: '100%',
        padding: '1rem',
        borderRadius: '0.25rem',
        border: `1px solid ${grey[500]}`,
      }}
    >
      <Typography variant="subtitle1" component="span" fontWeight="bold">
        {capitalize(type)}
      </Typography>

      <Stack gap="1rem" height="100%">
        <RenderWithCondition
          condition={!!reasons.length}
          fallBack={
            <Stack height="100%" gap="1rem" alignItems="center" justifyContent="center">
              <Typography variant="subtitle1" component="span" color="textSecondary">
                List of {capitalize(type)} reasons empty
              </Typography>
              <Box sx={{ alignSelf: !!reasons.length ? 'flex-start' : 'center' }}>
                <Button startIcon={<Add />} loading={loading.isCreating} onClick={handleAddReason}>
                  Add
                </Button>
              </Box>
            </Stack>
          }
        >
          {reasons.map(reason => (
            <CloseReasonField key={reason.id} reason={reason} />
          ))}
        </RenderWithCondition>

        {!!reasons.length && (
          <Box sx={{ alignSelf: !!reasons.length ? 'flex-start' : 'center' }}>
            <Button startIcon={<Add />} loading={loading.isCreating} onClick={handleAddReason}>
              Add
            </Button>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
